import { Controller } from "@hotwired/stimulus";

export default class StackCollapseController extends Controller {
  static override values = { maxItems: Number };
  declare readonly maxItemsValue: number;

  static override targets = ["item", "expandButton", "expandText"];
  declare readonly itemTargets: HTMLElement[];
  declare readonly expandButtonTarget: HTMLElement;
  declare readonly expandTextTarget: HTMLElement;

  private isExpanded = false;
  private hiddenCount = 0;

  override connect(): void {
    const totalItems = this.itemTargets.length;

    if (totalItems <= this.maxItemsValue) {
      this.expandButtonTarget.remove();
      return;
    }

    this.hiddenCount = totalItems - this.maxItemsValue;
    this.collapse();
    this.expandButtonTarget.classList.remove("hidden");
  }

  toggle(): void {
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  private expand(): void {
    for (const item of this.itemTargets) {
      item.classList.remove("hidden");
    }

    this.expandTextTarget.textContent = "Show less";
    this.isExpanded = true;
  }

  private collapse(): void {
    const totalItems = this.itemTargets.length;
    for (let i = this.maxItemsValue; i < totalItems; i++) {
      this.itemTargets[i]?.classList.add("hidden");
    }

    this.expandTextTarget.textContent = `Show ${this.hiddenCount} more`;
    this.isExpanded = false;
  }
}
